import { Badge } from '@redbax/ui-kit';

const severityConfig: Record<string, { variant: 'destructive' | 'warning' | 'secondary' | 'outline'; label: string }> = {
  CRITICAL: { variant: 'destructive', label: 'Critical' },
  HIGH: { variant: 'warning', label: 'High' },
  MEDIUM: { variant: 'secondary', label: 'Medium' },
  LOW: { variant: 'outline', label: 'Low' },
};

export function SeverityBadge({ severity }: { severity: string | null }) {
  if (!severity) return <Badge variant="outline">Unknown</Badge>;
  const config = severityConfig[severity.toUpperCase()] ?? { variant: 'outline' as const, label: severity };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
